module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendar"
    }
  }, [_c('div', {
    staticClass: "row area-name area-name-bg"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "area_inner_side"
  }, [_c('div', {
    staticClass: "area_inner"
  }, [_c('h4', [_vm._v("City Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.calendarData ? _vm.calendarData.cityName : '--'))])]), _vm._v(" "), _c('div', {
    staticClass: "area_inner"
  }, [_c('h4', [_vm._v("Staff Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.calendarData ? _vm.calendarData.driverName : '--'))])]), _vm._v(" "), _c('div', {
    staticClass: "area_inner"
  }, [_c('h4', [_vm._v("Role type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.calendarData ? _vm.calendarData.roleType : '--'))])])])])]), _vm._v(" "), _c('calendar-view', {
    staticClass: "theme-default holiday-us-traditional holiday-us-official",
    attrs: {
      "show-date": _vm.showDate,
      "events": _vm.events,
      "display-period-uom": "month"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(t) {
        return _c('calendar-view-header', {
          attrs: {
            "header-props": t.headerProps
          },
          on: {
            "input": _vm.setShowDate
          }
        })
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3a23cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/helperAndDriverManagment/dutyTracking.vue
// module id = 2399
// module chunks = 1